"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parser = void 0;
const SplitscriptParser_1 = require("./SplitscriptParser");
class Parser extends SplitscriptParser_1.default {
    static NUMBER_TYPES = new Set([
        SplitscriptParser_1.default.FLOAT,
        SplitscriptParser_1.default.INT,
        SplitscriptParser_1.default.PERCENTAGE,
    ]);
    constructor(input) {
        super(input);
        this.removeErrorListeners();
    }
}
exports.Parser = Parser;
